import { v4 as uuidv4 } from "uuid";

function GenerateRandomUUID() {
  return uuidv4();
}

export default GenerateRandomUUID;
